import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Categories, Lang, Res } from 'src/app/models';
import { LanguageService, NotificationService } from 'src/app/services';
import { ApiCategoriesService } from 'src/app/services/api-categories.service';

@Component({
  selector: 'app-categories-actions',
  templateUrl: './categories-actions.component.html',
  styleUrls: ['./categories-actions.component.css']
})
export class CategoriesActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  categoryId: string;
  categories: Categories[] = [];
  language: string;
  loading: boolean;
  categoryName: Lang;

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  };

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null]
  });

  @Input() set data(value) {

    if (value != null) {

      this.categoryId = value.category_id;

    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiCategoriesService: ApiCategoriesService,
    public activeModal: NgbActiveModal,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
 * 
 * @param fieldName string
 * @param value Lang
 */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }

  /**
   * 
   */
  setDataInForm(data: any): any {

    // this.categoryName = this.categories.name;
  }


  /**
   * 
   */
  onSend(): void{

    this.activeModal.close(this.form.value);
  }

}
